import React from 'react';
import './Logo.css';

const Logo = ({ size = 'medium', className = '', onClick }) => {
  const getSizeClass = () => {
    switch (size) {
      case 'small':
        return 'logo-small';
      case 'large':
        return 'logo-large';
      case 'xlarge':
        return 'logo-xlarge';
      default:
        return 'logo-medium';
    }
  };

  return (
    <div 
      className={`logo-container ${getSizeClass()} ${className} ${onClick ? 'logo-clickable' : ''}`}
      onClick={onClick}
    >
      <img 
        src="/images/sempre-logo.png" 
        alt="Logo Sempre AgTech" 
        className="logo-image"
      />
    </div>
  );
};

export default Logo; 